window.Fav = {};

Fav.counter = 0;

Fav.init = function () {
  if (window.innerWidth <= 768) {
    return;
  }
  Fav.loadFavs();
  Fav.minifavTimeout = null;
  $('.header__rightbar a.wishlist').hover(function () {
    clearTimeout(Fav.minifavTimeout);
    MiniFav.onMouseEnter(function () {
      clearTimeout(Fav.minifavTimeout);
    });
    MiniFav.onMouseOut(function () {
      Fav.minifavTimeout = setTimeout(function () {
        MiniFav.hide();
      }, 1000);
    });
    MiniFav.show();
  }, function () {
    Fav.minifavTimeout = setTimeout(function () {
      MiniFav.hide();
    }, 1000);
  });
}

Fav.loadFavs = function (cb) {
  return jQuery.ajax({
    url: "/client/favorites/fetch",
    method: "post",
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      if (cb) {
        return cb(resp);
      }
      Fav.updateItemsQtyLabel(resp.favorites.length);
      MiniFav.update(resp.minifavPartial);
    }
  });
};

Fav.favProduct = function (productId, cb) {
  return jQuery.ajax({
    url: "/client/favorites/add?productId=" + productId,
    method: "post",
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      cb && cb(null, resp);
      Fav.loadFavs(function (resp) {
        Fav.updateItemsQtyLabel(resp.favorites.length);
        MiniFav.update(resp.minifavPartial);
        MiniFav.show(true);
        MiniFav.onMouseOut(function () {
          MiniFav.hide();
        });
      });

    },
    error: function (resp) {
      cb && cb(resp);
    }
  });
};

Fav.unFavProduct = function (productId, cb) {
  return jQuery.ajax({
    url: "/client/favorites/remove?productId=" + productId,
    method: "post",
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      cb && cb(null, resp);
    },
    error: function (resp) {
      cb && cb(resp);
    }
  });
};

Fav.updateItemsQtyLabel = function (number) {
  var spanQ = 'a.wishlist > span';
  var span = $(spanQ);
  if (number === 0) {
    span.remove();
    return;
  }
  if (!span.length) {
    $('a.wishlist').append("<span></span>");
    span = $(spanQ);
  }
  span.html(number);
};

Fav.checkIfProductPageAndUpdate = function (response) {
  if (typeof ProductPage === 'undefined' || !ProductPage.product || !ProductPage.product._id) {
    return;
  }
  if (response.favorites && response.favorites.indexOf(ProductPage.product._id) >= 0) {
    $('.fav').hide();
    $('.unfav').show();
  } else {
    $('.fav').show();
    $('.unfav').hide();
  }
};

var MiniFav = Fav.MiniFav = {};

MiniFav.show = function (hasNewItem) {
  hasNewItem ? $('.minifav_object .alert').show() : $('.minifav_object .alert').hide();
  $('.minifav_object').show();
};

MiniFav.onMouseEnter = function (cb) {
  $('.minifav_object').unbind("mouseenter").mouseenter(cb);
};

MiniFav.onMouseOut = function (cb) {
  $('.minifav_object').unbind("mouseleave").mouseleave(cb);
};

MiniFav.hide = function () {
  $('.minifav_object').hide();
};

MiniFav.update = function (html) {
  $('.minifav_object').replaceWith(html);
  $('.minifav_object .item .remove').each(function (i, link) {
    $(link).click(function (event) {
      event.preventDefault();
      $(link).parent().remove();
      Fav.unFavProduct(this.id, function (response) {
        CatalogPage.markFavs();
        Fav.loadFavs(function (response) {
          Fav.checkIfProductPageAndUpdate(response);
          MiniFav.update(response.minifavPartial);
          Fav.updateItemsQtyLabel(response.favorites.length || 0);
          MiniFav.show();
          MiniFav.onMouseOut(function () {
            MiniFav.hide();
          });
        });
      });
    });
  });
};

$(Fav.init);